import React from "react";

import { PropsTypeSvg } from "@typings/global.types";

function ChevronRoundedLastExercisedSVG({
  classNameProps,
  height,
  width,
}: PropsTypeSvg) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNameProps}
      width={width}
      height={height}
      viewBox='0 0 30 30'
      fill='none'
    >
      <rect
        width='30'
        height='30'
        rx='15'
        className='dark:fill-bg-dark-secondary fill-bg-secondary'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.9697 9.96967C13.2626 9.67678 13.7374 9.67678 14.0303 9.96967L19.0607 15L14.0303 20.0304C13.7374 20.3233 13.2626 20.3233 12.9697 20.0304C12.6768 19.7375 12.6768 19.2626 12.9697 18.9697L16.9394 15L12.9697 11.0303C12.6768 10.7374 12.6768 10.2626 12.9697 9.96967Z'
        className='dark:fill-icon-dark-primary fill-icon-primary'
      />
    </svg>
  );
}

export default ChevronRoundedLastExercisedSVG;
